import { Button, MenuItem, Typography } from '@mui/material';
import { Check } from '@ankr.com/ui';

import { Avatar } from 'modules/teams/components/Avatar';
import { getTeamAccountAvatarColor } from 'modules/teams/utils/getTeamAccountAvatarColor';
import { getTeamRoleName } from 'modules/teams/utils/getTeamRoleName';

import { UseAccountItemProps, useAccountItem } from './hooks/useAccountItem';
import { useAccountItemStyles } from './useAccountItemStyles';

export interface AccountItemProps extends UseAccountItemProps {}

export const AccountItem = (props: AccountItemProps) => {
  const { isPersonalAccount, isSelected, onClick } = useAccountItem(props);
  const {
    account: { index, name, role },
  } = props;

  const { classes } = useAccountItemStyles();

  return (
    <MenuItem
      className={classes.menuItem}
      component={Button}
      onClick={onClick}
      variant="text"
    >
      <Avatar
        avatarColor={getTeamAccountAvatarColor(index)}
        className={classes.avatar}
        name={name}
      />
      <div className={classes.groupInfoWrapper}>
        <div className={classes.labelWrapper}>
          {!isPersonalAccount && (
            <Typography variant="body4" color="textSecondary" fontWeight={500}>
              {getTeamRoleName(role)}
            </Typography>
          )}
        </div>
        <Typography className={classes.userName} variant="body3">
          {name}
        </Typography>
      </div>
      {isSelected && <Check className={classes.check} />}
    </MenuItem>
  );
};
